module.exports = __webpack_public_path__ + "img/mode.727799d2.svg";